














import { computed, defineComponent, PropType, toRefs } from '@nuxtjs/composition-api'

const searchConditionSelectContentWrapper = defineComponent({
  name: 'SearchConditionSelectContentWrapper',
  props: {
    contentHeight: {
      type: Number as PropType<number>,
      default: 0
    }
  },
  setup(props) {
    const { contentHeight } = toRefs(props)
    const contentStyle = computed(() => {
      return {
        maxHeight: `${contentHeight.value}px`
      }
    })
    return {
      contentStyle
    }
  }
})

export default searchConditionSelectContentWrapper
